module.exports = __webpack_public_path__ + "img/map-person2.efe2d6c5.png";